import type { PanelFocus, PanelView } from "../state/panel";
import type { ConfirmationAction } from "../ctui/chat/types";

export type Step =
  | {
      kind: "msg";
      id: string;
      tokens: string;
      msPerChar?: number;
      pauseAfter?: number;
    }
  | {
      kind: "panel";
      view: PanelView;
      focus: PanelFocus;
      pauseAfter?: number;
    }
  | {
      kind: "confirm";
      id: string;
      title: string;
      body?: string;
      actions: ConfirmationAction[];
      autoResolveAfter?: number;
      autoResolveKey?: "1" | "2" | "3";
    }
  | {
      /** Autonomous action — ripper decides, user can override. */
      kind: "act";
      id: string;
      title: string;
      body?: string;
      receipt: string;
      actMs?: number;
    }
  | { kind: "pause"; ms: number }
  | {
      kind: "listen";
      /** Optional prompt chips surfaced after handover. */
      suggestions?: string[];
    };

import { openingHook } from "./steps/00-opening-hook";
import { scanComplete } from "./steps/01-scan-complete";
import { worstOffenders } from "./steps/01b-worst-offenders";
import { sparkConnectDrift } from "./steps/02-sparkconnect-drift";
import { siteAudit } from "./steps/02c-site-audit";
import { ethocaAlerts } from "./steps/03-ethoca-alerts";
import { ce3MatchBatch } from "./steps/04-ce3-match-batch";
import { crossMerchantPattern } from "./steps/05-cross-merchant-pattern";
import { retentionForecast } from "./steps/06-retention-forecast";
import { listening } from "./steps/07-listening";

export const SCRIPT: Step[] = [
  ...openingHook,
  ...scanComplete,
  ...worstOffenders,
  ...sparkConnectDrift,
  ...siteAudit,
  ...ethocaAlerts,
  ...ce3MatchBatch,
  ...crossMerchantPattern,
  ...retentionForecast,
  ...listening,
];
